import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import flyer from '../assets/flyer.jpeg';

export default function FlyerPopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const dismissed = sessionStorage.getItem('llcFlyerDismissed');
    if (!dismissed) {
      const timer = setTimeout(() => setOpen(true), 650);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    if (!open) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [open]);

  const close = () => {
    sessionStorage.setItem('llcFlyerDismissed', 'true');
    setOpen(false);
  };

  if (!open) return null;

  return createPortal(
    <div className="flyer-popup" role="dialog" aria-modal="true" aria-label="LinkedIn Local Cameroon event flyer">
      <button className="flyer-popup__backdrop" type="button" aria-label="Close flyer" onClick={close} />
      <div className="flyer-popup__card">
        <button className="flyer-popup__close" type="button" aria-label="Close flyer" onClick={close}>×</button>
        <div className="flyer-popup__media">
          <img src={flyer} alt="LinkedIn Local Cameroon 2026 flyer" />
        </div>
        <div className="flyer-popup__content">
          <div className="flyer-popup__eyebrow">October 10, 2026</div>
          <h3>Best Western Plus Hotel, Douala</h3>
          <p>Join 2,000+ delegates for LinkedIn Local Cameroon 2026.</p>
          <div className="flyer-popup__actions">
            <a href="#tickets" className="btn-primary" onClick={close}>Get tickets ↗</a>
            <button type="button" className="btn-outline" onClick={close}>Continue browsing</button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
